module.exports = __webpack_public_path__ + "img/23-consultas-docs-por-irregularidade-lista.83b9ee2a.png";